import {useEffect} from "react"
import usePermissions from "../hooks/usePermissions"
import useModal from "../hooks/useModal";
import Section from "../components/Section"
import SectionHeader from "../components/SectionHeader"
import SectionContent from "../components/SectionContent"
import List from "../components/List"

export default function Tags(){

    const {restrictSection}=usePermissions()
    useEffect(()=>{
        restrictSection("master","")
    },[])
    
    const {changeModal}=useModal()

    const edit=()=>{
        changeModal("tag-edit","",0)
    }

    return(
        <Section>
            <SectionHeader
                title="Etiquetas"
                intro="Categorías en las que pueden agruparse los comercios."
                back=""
                button={{label:"Nueva etiqueta",icon:"create",link:"",href:"",clickEvent:edit}}
                tabs={[
                    {label:"Todos los comercios",labelShort:"Comercios",to:"/c24/comercios"},
                    {label:"Etiquetas",to:"/c24/comercios/etiquetas"},
                    {label:"Acuerdos comerciales",labelShort:"Acuerdos",to:"/c24/comercios/acuerdos"}
                ]}
            />
            <SectionContent>
                <List config={{
                    section:"tags",
                    endpoint:"shops/tags",
                    limit:0,
                    counter:{
                        singular:"etiqueta",
                        plural:"etiquetas"
                    },
                    action:{
                        mode:"modal",
                        context:"",
                        reference:"tag-edit"
                    }
                }} />
            </SectionContent>
        </Section>
    )
    
}